import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Restaurant } from './types';

interface RestaurantState {
  details: Restaurant | null; // Define a more specific type if possible
}

const initialState: RestaurantState = {
  details: null,
};

const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    setRestaurantDetails(state, action: PayloadAction<any>) {
      state.details = action.payload;
    },
    clearRestaurantDetails(state) {
      state.details = null;
    },
  },
});

export const { setRestaurantDetails, clearRestaurantDetails } =
  restaurantSlice.actions;
export default restaurantSlice.reducer;
